  <div class="container-fluid bg-transparent">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <p class="mb-0 fw-bold text-xs">Select Verification Services to Run</p>
      <button
        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark d-none"
        data-bs-toggle="modal"
        data-bs-target="#verification_logs"
        @click.stop="open_verification_logs"
      >
        Verification Logs
      </button>
    </div>

    <div class="">
      <AutoVerificationServices
        :application_id="application_id"
        :entity_profile_id="entity_profile_id"
        :auto_fetch="true"
      />
    </div>
  </div>

<!-- Verification logs Modal -->
<teleport to="body">
<div class="modal fade" id="verification_logs" tabindex="-1" aria-labelledby="verification_logs_label" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
    <div class="modal-header border-bottom-0 cute-header shadow-lg">
      <p class="modal-title text-white text-xxs" id="verification_logs_label">Verification logs</p>
      <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <div class="card shadow-sm border table-border-color rounded-lg p-3 table-responsive text-xs">
          <table id="verification_logs_table" class="table table-hover">
              <thead class="custom-header">
                <tr>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Service Name</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Message</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="log in verification_logs" :key="log.id">
                  <td class="text-xxs text-start">{{ get_service_name(log.service_id) }}</td>
                  <td class="text-xxs text-start">{{ log.status }}</td>
                  <td class="text-xxs text-start text-wrap">
                    {{ get_display_message(log.message) }}
                  </td>
                  <td class="text-xxs text-start">{{ format_date(log.created_at) }}</td>
                </tr>
              </tbody>
          </table>
        </div>
    </div>
  </div>
</div>
</div>
</teleport>